const SET_RESEARCH_TAGS = (state, payload) => {
  console.log(payload.data.data)
  if (Array.isArray(payload.data.data)) {
    state.tags = payload.data.data
  }
  // console.log('test')
  // console.log(payload)
}
const SET_RESEARCH_TAG_STATE = (state, payload) => {
  state.ready = payload
}

export default {
  SET_RESEARCH_TAG_STATE,
  SET_RESEARCH_TAGS
}
